module.exports = __webpack_public_path__ + "static/Moderat-Regular-3c144790c77538f48ac964029d7101a9.woff2";